import { render, staticRenderFns } from "./StudyPlansTableTermsSubjects.vue?vue&type=template&id=32774a00&"
import script from "./StudyPlansTableTermsSubjects.vue?vue&type=script&lang=js&"
export * from "./StudyPlansTableTermsSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports